import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar, { MOBILE_TABBAR_HEIGHT } from "../components/Sidebar";
import { Box, CircularProgress } from "@mui/material";

const SIDEBAR_COLLAPSED = 72;

const SiteLayout = function () {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, 1000);
  }, []);

  return (
    <div style={{ position: "fixed", inset: 0, display: "flex", flexDirection: "row" }}>
      {load ? (
        <div className="flex flex-col gap-4 w-full h-full justify-center items-center">
          <CircularProgress size={60} color="primary" />
        </div>
      ) : (
        <>
          <Sidebar />
          <Box
            component="main"
            sx={{
              flex: 1,
              overflow: "auto",
              minHeight: 0,
              // Masaüstünde (md+) sidebar kalıcı bir ray olduğu için içerik
              // ondan sonra başlar. Mobilde ray hiç render edilmez — navigasyon
              // ekranın altındaki tab bar'dır, o yüzden sol boşluk yok ama
              // içeriğin son satırı bar'ın altında kalmasın diye alt boşluk var.
              marginLeft: { xs: 0, md: `${SIDEBAR_COLLAPSED}px` },
              paddingBottom: { xs: `${MOBILE_TABBAR_HEIGHT}px`, md: 0 },
            }}
          >
            <Outlet />
          </Box>
        </>
      )}
    </div>
  );
};

export default SiteLayout;
